import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export const CustomModal = ({
  isOpen,
  toggle,
  header,
  body,
  footer,
  bodyClasses,
  footerClasses,
  headerClasses,
  size,
  style,
  backdrop = 'static',
}) => {
  return (
    <Modal
      size={size ? size : ''}
      isOpen={isOpen}
      toggle={toggle}
      backdrop={backdrop}
      style={style ? style : {}}
    >
      <ModalHeader
        toggle={toggle}
        className={`border-bottom ${headerClasses ? headerClasses : ''}`}
      >
        {header ? header : ''}
      </ModalHeader>
      <ModalBody className={bodyClasses ? bodyClasses : ''}>{body ? body : ''}</ModalBody>
      <ModalFooter className={footerClasses ? footerClasses : ''}>
        {footer ? footer : ''}
      </ModalFooter>
    </Modal>
  );
};
